import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Prevent body scrolling when modal is open
    document.body.style.overflow = "hidden";
  }

  disconnect() {
    // Restore body scrolling
    document.body.style.overflow = "";
  }

  close(event: Event) {
    event.preventDefault();

    // Remove the modal content from the turbo frame
    const turboFrame = document.getElementById("modal");

    if (turboFrame) {
      turboFrame.innerHTML = "";
    }

    // Restore body scrolling
    document.body.style.overflow = "";
  }
}
